import { QuestionSlide as QuestionSlideType, QuestionsByDifficulty } from 'types'
import { Slide } from './types'

const calculateSlideApproved = (questionsByDifficulty: QuestionsByDifficulty[] = []): boolean => {
  return questionsByDifficulty.every(
    diffQuestions => diffQuestions.questions.every(q => q.approved)
  )
}

export const buildSlides = (numSlides: number, questionSlides: QuestionSlideType[]) => {
  const slides: Slide[] = Array(numSlides).fill(null).flatMap((_, i) => [
    { type: 'presentation' as const, index: i },
    ...questionSlides
      .filter((q: QuestionSlideType) => q.slide === i)
      .map((q: QuestionSlideType) => ({
        ...q,
        index: i,
        type: 'question' as const,
        id: crypto.randomUUID(),
        // Each assessment stage uses its OWN questions (with correct section-appended IDs)
        // Pre-Assessment questions have IDs like "abc123_Pre-Assessment"
        // Post-Assessment questions have IDs like "abc123_Post-Assessment"
        questionsByDifficulty: q.questionsByDifficulty,
        allApproved: calculateSlideApproved(q.questionsByDifficulty)
      }))
  ])

  return { slides }
}


